import { createTheme, responsiveFontSizes } from "@mui/material";

let theme = createTheme({
  palette: {
    primary: {
      main: "#000000",
    },
  },
});

theme = responsiveFontSizes(theme);

export default theme;
